import React from 'react'
import './hero.css'
import 'animate.css';
import LMB from '../../Assets/Img/img-hero-2.png'

function Hero() {
  return (
    <section className='hero' id='home'>
      <img src={LMB} alt="Luis Miguel Barthaburu imagen de perfil" className='imagen-hero'/>
      <div className='clippath-hero'></div>
      <div className='text animate__animated animate__fadeIn animate__delay-2s'>
        <h1 className='name'>Luis Barthaburu</h1>
        {/* <div className='list'>
          <div className='list-container'>
            <div className='list-item'>Web Developer</div>
            <div className='list-item'>Frontend Developer</div>
            <div className='list-item'>Backend Developer</div>
            <div className='list-item'>Full Stack Developer</div>
            <div className='list-item'>UI/UX Designer</div>
          </div>
        </div> */}
        <h2 className='hero-skill text animate__animated animate__fadeIn animate__delay-2s'>FRONT-END <br />DEVELOPER <br /></h2>
      </div>
      <div className='clippath animate__animated animate__fadeIn animate__delay-2s '></div>
    </section>
  )
}

export default Hero